// Import the functions you need from the SDKs you need
import { UserData } from "@/data/interfaces/UserDataInterface";
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  getDoc,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_AUTH_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(firebaseApp);

//initialize firebase auth
const auth = getAuth();

export { firebaseApp, auth, db, RecaptchaVerifier };

export const users = collection(db, "users");

export const getUser = async (id: string) => {
  const docRef = doc(db, "users", id.toString());
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? docSnap.data() : [];
};

export const addUser = async (id: string, data: UserData) => {
  const userRef = doc(db, "users", id.toString());
  await setDoc(userRef, data, { merge: true });
};
